import React from "react";
import { Link } from "react-router-dom";
import Logo from "../images/logo/logo.png";

function Footer() {
  return (
    <div className="bg-light">
      <section>
        <div className="sec_pd">
          <footer className="py-5">
            <div className="row align-items-start"> 
              {/* Logo Section */}
              <div className="col-md-2 d-flex justify-content-center justify-content-md-start">
                <img src={Logo} alt="logo " className="foot-logo"  width={200} height={200} />
              </div>

              {/* Navigation Links */}
              {[
                    [
                      { name: "Home", link: "/home" },
                      { name: "About Us", link: "/aboutus" },
                      { name: "Auction", link: "/auction" },
                      // { name: "News", link: "/news" },
                      { name: "FAQs", link: "/faq" },
                      { name: "Contact Us", link: "/contactus" }
                    ],
                    [
                      { name: "Terms & Conditions", link: "/terms&conditions" },
                      { name: "Privacy Policy", link: "/privacypolicy" },
                      { name: "Refund Policy", link: "/refundpolicy" },
                      { name: "Security Policy", link: "/securitypolicy" },
                      { name: "Cookies Policy", link: "/cookiespolicy" },
               
                    ]
                  ].map((items, index) => (
                    <div key={index} className="col-6 col-md-2">
                      <h5 className="text-black fw-bold">Quick Links</h5>
                      <ul className="nav flex-column">
                        {items.map((item, idx) => (
                          <li key={idx} className="nav-item mb-2">
                            <Link to={item.link} className="nav-link p-0 text-body-secondary">
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}


              {/* Newsletter Section */}
              <div className="col-md-5 offset-md-1 sub_sec">
                <form className="form_sub">
                  <h3 className="text-black">Anachronistic Auction House</h3>
                  <p className="text-black mb-2">Dubai, United Arab Emirates</p>
                  <h5 className="text-black">Subscribe to our newsletter</h5>
                  <p className="text-black">Monthly digest of what's new and exciting from us.</p>
                  <div className="d-flex flex-column flex-sm-row w-100 gap-2">
                    <label htmlFor="newsletter1" className="visually-hidden">
                      Email address
                    </label>
                    <input id="newsletter1" type="text" className="form-control" placeholder="Email address" />
                    {/* <button className="btn btn-warning text-white" type="button">
                      Subscribe
                    </button> */}
                     <Link
                                        to='/home'
                                        className="btn signup-btn text-white  position-relative overflow-hidden border-0"
                                      >
                                        <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                                          <p className="m-0 text-black fw-bold button_name">
                                          Subscribe
                                          </p>
                                        </div>
                                      </Link>
                  </div>
                </form>
              </div>
            </div>

            {/* Footer Bottom */}
            <div className="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top">
              <p className="text-black">© 2026 Anachronistic Auction House, Inc. All rights reserved.</p>
            </div>
          </footer>
        </div>
      </section>
    </div>
  );
}

export default Footer;
